import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { TouchableOpacity } from 'react-native';

import { useNavigation } from '@react-navigation/native';

import ChevronRight from '@/assets/icons/chevronRight';
import { FilterIcon } from '@/assets/icons/filter';
import { Text } from '@/components/TextComponent';
import { Box, Row } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { designSystem } from '@/styles/styles';

import { CheckoutWidget } from './CheckoutWidget';

export const EditQuickAmountsButton = memo(() => {
    const { t } = useTranslation('betslip_pickem');

    const navigation = useNavigation();

    return (
        <TouchableOpacity onPress={() => navigation.navigate('EditQuickAmounts')}>
            <CheckoutWidget>
                <Row gap={'s16'} alignItems={'center'}>
                    <FilterIcon />
                    <Box flex={1}>
                        <Text
                            variant={'bodyLarge'}
                            lineHeight={24}
                            letterSpacing={-0.43}
                            color={ds.colorToken.text.primary}
                        >
                            {t('quick_amounts_edit_amounts')}
                        </Text>
                    </Box>
                    <ChevronRight color={designSystem.colors.neutral300} />
                </Row>
            </CheckoutWidget>
        </TouchableOpacity>
    );
});
